import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useEffect, type JSX } from 'react';

export const ProtectedRoute = () => {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn === false) {
      navigate('/login', {
        replace: true,
        state: { from: location.pathname + location.search },
      });
    }
  }, [isLoggedIn, navigate, location]);

  return <Outlet />;
};
